import { useQuery } from '@tanstack/react-query';
import { keys } from '@/lib/queryKeys';
import { fetchPurchaseOrders } from './api';

/** Tenant-wide — see queryKeys.ts's procurement comment. */
export function usePurchaseOrders() {
  return useQuery({ queryKey: keys.procurement.purchaseOrders(), queryFn: fetchPurchaseOrders });
}
